module.exports = __webpack_public_path__ + "img/snow_test.fa2a7869.jpg";